import { site, waLink } from "@/data/site";

export default function WhatsAppButton() {
  return (
    <a
      href={waLink("Hello AV Clinic, I would like to book an appointment.")}
      target="_blank"
      rel="noreferrer noopener"
      aria-label="Chat with AV Clinic on WhatsApp"
      className="fixed bottom-6 right-6 z-40 hidden lg:flex w-14 h-14 items-center justify-center rounded-full bg-secondary-500 text-background-50 shadow-soft hover:bg-secondary-600 hover:scale-105 transition-all duration-300"
    >
      <i className="ri-whatsapp-line text-2xl" />
    </a>
  );
}